export default {
  name: 'Footer',
  props: [ ],
  components: { },
  mounted() { },
  data() {
    return { }
  },
  methods: { },
  computed: { },
  mounted() { },
  created() { }
}



// WEBPACK FOOTER //
// ./src/components/Footers/Footer/Footer.component.js